"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartupApi = exports.SectorTag = exports.StakeTag = exports.SubDomainTag = exports.DomainTag = exports.InnovationTagEnum = void 0;
const axios_1 = require("axios");
const base_1 = require("../base");
const globalImportUrl = require("url");
var InnovationTagEnum;
(function (InnovationTagEnum) {
    InnovationTagEnum["domain"] = "domain";
    InnovationTagEnum["stake"] = "stake";
    InnovationTagEnum["sector"] = "sector";
})(InnovationTagEnum = exports.InnovationTagEnum || (exports.InnovationTagEnum = {}));
var DomainTag;
(function (DomainTag) {
    DomainTag["domainInnovativeAgriculturalProduction"] = "domainInnovativeAgriculturalProduction";
    DomainTag["domainOnlineFarmingCommunity"] = "domainOnlineFarmingCommunity";
    DomainTag["domainLogisticAndAdministrativeTools"] = "domainLogisticAndAdministrativeTools";
})(DomainTag = exports.DomainTag || (exports.DomainTag = {}));
var SubDomainTag;
(function (SubDomainTag) {
    SubDomainTag["subdomainPrecisionAgriculture"] = "subdomainPrecisionAgriculture";
    SubDomainTag["subdomainAnimalWellbeing"] = "subdomainAnimalWellbeing";
    SubDomainTag["subdomainBio"] = "subdomainBio";
    SubDomainTag["subdomainRobotics"] = "subdomainRobotics";
    SubDomainTag["subdomainGuidanceSystem"] = "subdomainGuidanceSystem";
    SubDomainTag["subdomainRemoteSensing"] = "subdomainRemoteSensing";
    SubDomainTag["subdomainWeather"] = "subdomainWeather";
    SubDomainTag["subdomainMarketPlace"] = "subdomainMarketPlace";
    SubDomainTag["subdomainShortCircuits"] = "subdomainShortCircuits";
    SubDomainTag["subdomainSocialNetworks"] = "subdomainSocialNetworks";
    SubDomainTag["subdomainCrowdfunding"] = "subdomainCrowdfunding";
    SubDomainTag["subdomainCollaborativeTool"] = "subdomainCollaborativeTool";
    SubDomainTag["subdomainDecision"] = "subdomainDecision";
    SubDomainTag["subdomainAgriculturalLogistics"] = "subdomainAgriculturalLogistics";
    SubDomainTag["subdomainAdministrativeManagement"] = "subdomainAdministrativeManagement";
    SubDomainTag["subdomainManagementTool"] = "subdomainManagementTool";
    SubDomainTag["subdomainQualityTraceability"] = "subdomainQualityTraceability";
    SubDomainTag["subdomainRSE"] = "subdomainRSE";
})(SubDomainTag = exports.SubDomainTag || (exports.SubDomainTag = {}));
var StakeTag;
(function (StakeTag) {
    StakeTag["stakeProfitability"] = "stakeProfitability";
    StakeTag["stakeSocietalIssues"] = "stakeSocietalIssues";
    StakeTag["stakeEnvironmentalImpacts"] = "stakeEnvironmentalImpacts";
})(StakeTag = exports.StakeTag || (exports.StakeTag = {}));
var SectorTag;
(function (SectorTag) {
    SectorTag["sectorBigCultures"] = "sectorBigCultures";
    SectorTag["sectorBreeding"] = "sectorBreeding";
    SectorTag["sectorFruitsAndVegetables"] = "sectorFruitsAndVegetables";
    SectorTag["sectorVineAndWine"] = "sectorVineAndWine";
})(SectorTag = exports.SectorTag || (exports.SectorTag = {}));
function StartupApiAxiosParamCreator(configuration) {
    return {
        search(q, contentTypes, searchType, stakes, domains, sectors, isHostedByCa, offset, limit, options = {}) {
            const localVarPath = `/content-search`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter["q"] = q;
            }
            if (contentTypes) {
                localVarQueryParameter["contentTypes[]"] = contentTypes;
            }
            if (searchType !== undefined) {
                localVarQueryParameter["searchType"] = searchType;
            }
            if (stakes) {
                localVarQueryParameter["stakes[]"] = stakes;
            }
            if (domains) {
                localVarQueryParameter["domains[]"] = domains;
            }
            if (sectors) {
                localVarQueryParameter["sectors[]"] = sectors;
            }
            if (isHostedByCa !== undefined) {
                localVarQueryParameter["isHostedByCa"] = isHostedByCa;
            }
            if (offset !== undefined) {
                localVarQueryParameter["offset"] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter["limit"] = limit;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStartup(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getStartup.");
            }
            const localVarPath = `/startups/{slug}`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRelatedStartups(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getRelatedStartups.");
            }
            const localVarPath = `/startups/{slug}/related`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getContactImageDefaut(options = {}) {
            const localVarPath = `/startups/contact/image`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function InnovationApiFp(configuration) {
    return {
        search(q, contentTypes, searchType, stakes, domains, sectors, isHostedByCa, offset, limit, options) {
            const localVarAxiosArgs = StartupApiAxiosParamCreator(configuration).search(q, contentTypes, searchType, stakes, domains, sectors, isHostedByCa, offset, limit, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getStartup(slug, options) {
            const localVarAxiosArgs = StartupApiAxiosParamCreator(configuration).getStartup(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getRelatedStartups(slug, options) {
            const localVarAxiosArgs = StartupApiAxiosParamCreator(configuration).getRelatedStartups(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getContactImageDefaut(options) {
            const localVarAxiosArgs = StartupApiAxiosParamCreator(configuration).getContactImageDefaut(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class StartupApi extends base_1.BaseAPI {
    search(q, contentTypes, searchType, stakes, domains, sectors, isHostedByCa, offset, limit, options) {
        return InnovationApiFp(this.configuration).search(q, contentTypes, searchType, stakes, domains, sectors, isHostedByCa, offset, limit, options)(this.axios, this.basePath);
    }
    getStartup(slug, options) {
        return InnovationApiFp(this.configuration).getStartup(slug, options)(this.axios, this.basePath);
    }
    getRelatedStartup(slug, options) {
        return InnovationApiFp(this.configuration).getRelatedStartups(slug, options)(this.axios, this.basePath);
    }
    getContactImageDefaut(options) {
        return InnovationApiFp(this.configuration).getContactImageDefaut(options)(this.axios, this.basePath);
    }
}
exports.StartupApi = StartupApi;
